import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import AnimateSection from '@/components/base/AnimateSection';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import ArticlesGrid from './components/ArticlesGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <SchemaOrg />
      <Navbar />
      <HeroSection />
      <AnimateSection><AboutSection /></AnimateSection>
      <AnimateSection><CategoryGrid /></AnimateSection>
      <AnimateSection><FeatureGrid /></AnimateSection>
      <AnimateSection><ArticlesGrid /></AnimateSection>
      <AnimateSection><TestimonialSection /></AnimateSection>
      <AnimateSection><CTASection /></AnimateSection>
      <Footer />
    </main>
  );
}